import React, {FC} from 'react';

import bgm1 from 'assets/v3/guide/video/bgm-1.webp';
import bgm2 from 'assets/v3/guide/video/bgm-2.webp';
import dubConfig from 'assets/v3/guide/video/dub-config.webp';
import editEntry from 'assets/v3/guide/video/edit-entry.webp';
import editSubtitle from 'assets/v3/guide/video/edit-subtitle.webp';
import exportImg from 'assets/v3/guide/video/export.webp';
import intro from 'assets/v3/guide/video/intro.webp';
import subtitleStyle1 from 'assets/v3/guide/video/subtitle-style-1.webp';
import subtitleStyle2 from 'assets/v3/guide/video/subtitle-style-2.webp';
import translating from 'assets/v3/guide/video/translating.webp';
import ttsConfig from 'assets/v3/guide/video/tts-config.webp';
import upload from 'assets/v3/guide/video/upload.webp';
import voiceToggle1 from 'assets/v3/guide/video/voice-toggle-1.webp';
import voiceToggle2 from 'assets/v3/guide/video/voice-toggle-2.webp';

/** 使用指南「视频翻译」tab 中文正文。2026-09-17 按业务最新版《新版象寄视频翻译使用指南》
 * （docx）重写：功能简介 + 上传视频（配音/背景音乐/字幕配置）+ 字幕编辑和朗读 + 导出，
 * 截图取自 docx 内嵌图（webp 本地化）。壳组件负责 tab 切换与 h1。 */
const ZhContent: FC = () => {
  return (
    <>
      <h2>视频翻译功能介绍</h2>
      <ul>
        <li>
          <strong>识别音频翻译</strong>
          ：支持无字幕纯人声音频视频（同样支持带有原始字幕视频）上传翻译，通过识别音频进行外语翻译，还可按需选择是否配置字幕
        </li>
        <li>
          <strong>识别字幕翻译</strong>：支持带有原始字幕的视频上传翻译，AI 自动翻译字幕后给译后字幕进行外语配音
        </li>
        <li>
          <strong>去除文字</strong>：带有文字视频上传识别去除文字
        </li>
      </ul>
      <img alt="视频翻译功能介绍" decoding="async" loading="lazy" src={intro} />

      <h2>操作一：上传视频</h2>
      <p>这里以选择识别语音翻译为例，按需选择好语言上传视频。</p>
      <img alt="上传视频并选择语言" decoding="async" loading="lazy" src={upload} />

      <h3>智能配音配置</h3>
      <p>智能配音默认为开启状态，点击智能配音框右侧弹窗可试听并按需选择不同音频。</p>
      <img alt="智能配音配置" decoding="async" loading="lazy" src={dubConfig} />

      <h3>启用背景音乐</h3>
      <p>
        启用背景音乐默认为原始音频去人声，这个选择可以帮我们去除视频中的中文旁白，保留音乐音效，还可以根据需求在我们的音乐库里自主选择。
      </p>
      <img alt="背景音乐配置" decoding="async" loading="lazy" src={bgm1} />
      <img alt="音乐库选择" decoding="async" loading="lazy" src={bgm2} />

      <h3>字幕样式配置</h3>
      <p>按需开启关闭是否配置字幕，开启后字幕的样式位置可自由设置。</p>
      <img alt="字幕样式配置" decoding="async" loading="lazy" src={subtitleStyle1} />
      <img alt="字幕位置设置" decoding="async" loading="lazy" src={subtitleStyle2} />

      <p>上传完成，视频进行翻译。</p>
      <img alt="视频翻译进行中" decoding="async" loading="lazy" src={translating} />

      <h2>操作二：视频字幕编辑和朗读</h2>
      <p>翻译完成后的视频支持预览直接下载导出，也可以二次修改编辑。点击【编辑】按钮进入视频翻译编辑工作台。</p>
      <img alt="进入视频编辑工作台" decoding="async" loading="lazy" src={editEntry} />

      <p>
        点击任意字幕或文本右侧会弹出【编辑字幕】弹窗，文本编辑区支持对所选文本字幕的内容、字体、大小、颜色等修改处理。
      </p>
      <img alt="编辑字幕弹窗" decoding="async" loading="lazy" src={editSubtitle} />

      <h3>朗读配置</h3>
      <p>
        点击【朗读配置】可进行字幕配音修改。字幕的内容和朗读配置修改完成后，点击【试听】按钮，可自动生成修改后的朗读音频并替换自动配音音频。
      </p>
      <img alt="朗读配置" decoding="async" loading="lazy" src={ttsConfig} />

      <p>如果有一些标题不需要朗读或者漏读情况，可点击本条字幕，进行有声字幕和纯文本切换（可来回自由切换）。</p>
      <img alt="有声字幕与纯文本切换" decoding="async" loading="lazy" src={voiceToggle1} />
      <img alt="字幕朗读开关" decoding="async" loading="lazy" src={voiceToggle2} />

      <h2>操作三：视频导出</h2>
      <p>视频修改完成后，点击右上角【导出】按钮，按需选择画质导出后用于发布。</p>
      <img alt="视频导出" decoding="async" loading="lazy" src={exportImg} />
    </>
  );
};

export default ZhContent;
